<div class="homeSideBar">
    <div class="homeLoginArea">
        <span class="homeSideBarHeader" [innerHTML]="'ACCOUNT_CHANGEPIN_TITLE' | translate"></span>
        <div class="departureTimeListArea">
            <div class="tab-pane">
                <p class="formPagesInfoText ng-binding" [innerHTML]="'ACCOUNT_CHANGEPIN_DESCRIPTION' | translate"></p>
                <input class="formInput phoneNumberWrapperInputs" type="password" onlyNumber minlength="6" maxlength="6" [(ngModel)]="obUserPin.oldPin" [placeholder]="'ACCOUNT_CHANGEPIN_OLD_PASSWORD_PLACEHOLDER' | translate" *ngIf="isCreateNewPin === false" required>
                <input class="formInput phoneNumberWrapperInputs" type="password" onlyNumber minlength="6" maxlength="6" [(ngModel)]="obUserPin.newPin" [placeholder]="'ACCOUNT_CHANGEPIN_NEW_PIN_PLACEHOLDER' | translate" required>
                <input class="formInput phoneNumberWrapperInputs" type="password" onlyNumber minlength="6" maxlength="6" [(ngModel)]="obUserPin.newPinRepeat" [placeholder]="'ACCOUNT_CHANGEPIN_NEW_PIN_REPEAT_PLACEHOLDER' | translate" required>
                <a 
                    type="button" 
                    class="formButton" 
                    (click)="savePin()" 
                    [innerHTML]="'ACCOUNT_CHANGEPIN_SAVE_PIN_BUTTON' | translate"
                ></a>
                <a 
                    type="button" 
                    class="formButton cancel" 
                    [innerHTML]="'SIDEMENU_SETTINGS_BACK_LABEL' | translate"
                    (click)="onCancel()"
                >
                </a>
            </div>
        </div>
    </div>
    <app-download-app></app-download-app>
</div>